import "./JoinUs.module.css";
import Header from "@/reusable_sections/Header";
import GetConnected from "./sections/GetConnected";
import ThePhysicalHub from "./sections/ThePhysicalHub";
import CommonQueries from "./sections/CommonQueries";
import Footer from "@/reusable_sections/Footer";
export default function JoinUsPage() {
  return <div>
      <Header />
      <GetConnected />
      <ThePhysicalHub />
      <CommonQueries />
      <Footer />
    </div>;
}